import Header from "./components/Header"
import Container from "./components/Container"

function App() {
  return (
    <div className="App">
      <Header />
      <Container />
    </div>
  );
}

export default App;
